var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlugin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2968 3.50745C10.2968 3.06 9.93409 2.69727 9.48664 2.69727C9.03919 2.69727 8.67646 3.06 8.67646 3.50745V6.47813H8.40639C6.16913 6.47813 4.35547 8.29179 4.35547 10.5291V15.9303C4.35547 18.7642 6.65278 21.0615 9.48664 21.0615H12.1873V23.492C12.1873 23.9395 12.55 24.3022 12.9974 24.3022C13.4449 24.3022 13.8076 23.9395 13.8076 23.492V21.0615H16.5082C19.3422 21.0615 21.6394 18.7642 21.6394 15.9303V10.5291C21.6394 8.29179 19.8258 6.47813 17.5885 6.47813H17.3184V3.50745C17.3184 3.06 16.9557 2.69727 16.5082 2.69727C16.0608 2.69727 15.6981 3.06 15.6981 3.50745V6.47813H10.2968V3.50745Z",
    fill: "#FF7926"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugin);
export default __webpack_public_path__ + "static/media/plugin.75aa78bb940cd85824cca206ec518ce6.svg";
export { ForwardRef as ReactComponent };